/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts";
import { defaultPosition, IHasDimentions, IScreenModes, IScreenPosition } from "../data/interfaces";
import useLandingSize from "./useLandingSize";
import { ILandingConsoleStore, useLandingConsoleStore } from "../data/store";

export interface IPositionHook {
    position: IScreenPosition
    width: number
}
export default function usePosition (hd:IHasDimentions = {} as IHasDimentions, isClearPosition: boolean = false) : IPositionHook {
    const landingSizes = useLandingSize()
    const currentDimensionEdit:  WINDOW_WIDTH   = useLandingConsoleStore((state:ILandingConsoleStore) => state.currentDimensionEdit)
    
    // Если в режиме разработки -- берем текущую ширину режима, а иначе -- нирину контейнера
    const width = currentDimensionEdit === WINDOW_WIDTH.PANEL ? landingSizes.width : currentDimensionEdit

    const dimentions: IScreenModes = hd?.dimentions || {}
    const [position, setPosition] = useState<IScreenPosition>({ ...defaultPosition(isClearPosition), ...hd.position })
    
    //console.log( landingSizes )
    
    useEffect( () => {
        if( !hd || !!( hd as any ).isHidden )  {
            return
        }
        if(JSON.stringify(hd.position) === JSON.stringify(position)) {
            return
        }
        
        let _position = {}
        switch(true) {
            case width >= WINDOW_WIDTH.PANEL:          
                _position = ({ ...defaultPosition(isClearPosition), ...hd.position, ...dimentions[ WINDOW_WIDTH.PANEL ] })
                break
            case width >= WINDOW_WIDTH.LARGE:            
                _position = ({ ...defaultPosition(isClearPosition), ...hd.position, ...dimentions[ WINDOW_WIDTH.LARGE ] })
                break
            case width >= WINDOW_WIDTH.SCREEN:           
                _position = ({ ...defaultPosition(isClearPosition), ...hd.position, ...dimentions[ WINDOW_WIDTH.SCREEN ] })
                break
            case width >= WINDOW_WIDTH.TABLET:            
                _position = ({ ...defaultPosition(isClearPosition), ...hd.position, ...dimentions[ WINDOW_WIDTH.TABLET ] })
                break
            case width >= WINDOW_WIDTH.MOBILE:        
                _position = ({ ...defaultPosition(isClearPosition), ...hd.position, ...dimentions[ WINDOW_WIDTH.MOBILE ] })
                break
            case width >= WINDOW_WIDTH.SMALL:
                _position = ({ ...defaultPosition(isClearPosition), ...hd.position, ...dimentions[ WINDOW_WIDTH.SMALL ] })
                break
        }
        setPosition( _position )
    }, [ hd.position, width, landingSizes ] )
    return {
        position,
        width
    }
}